var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "hov" }, [
    _c(
      "div",
      {
        staticClass: "panel cursor-pointer",
        class: _vm.statusClass,
        attrs: { id: _vm.item._id },
        on: {
          click: function($event) {
            _vm.$router.push(_vm.link)
          }
        }
      },
      [
        _c(
          "div",
          { staticClass: "panel-header" },
          [
            _c("q-icon", {
              attrs: { name: _vm.statusIcon, color: "white", size: "20px" }
            }),
            _vm._v(" "),
            _c("span", { staticClass: "text-white" }, [
              _vm._v(" " + _vm._s(_vm.workDateLabel) + " ")
            ]),
            _vm._v(" "),
            _c("small", [_vm._v(_vm._s(_vm.item.label))])
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "panel-body" }, [
          _c(
            "p",
            [
              _vm.needPath
                ? _c("unit-path", {
                    attrs: { id: _vm.item.parent_id, withoutLink: true }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "p",
            [
              _c("q-icon", { attrs: { name: "fa-bell", color: "grey" } }),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.item.problem))])
            ],
            1
          ),
          _vm._v(" "),
          _vm.item.tasks
            ? _c(
                "p",
                [
                  _c("q-icon", { attrs: { name: "build", color: "grey" } }),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.item.tasks))])
                ],
                1
              )
            : _c(
                "p",
                [
                  _vm.item.result
                    ? _c("q-icon", { attrs: { name: "done", color: "grey" } })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.item.result))])
                ],
                1
              )
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-55fe19d0", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55fe19d0","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/case-item.vue
// module id = null
// module chunks = 